import { useLocation, type Location } from 'react-router-dom';
import { getMetricsRedirectPath } from 'views/Results/utils/metricsRedirectPath';

type MetricsRedirect = {
  to: Partial<Location>;
  state: unknown;
};

/**
 * Keeps old insights/* URLs working by redirecting them to metrics/*,
 * preserving query, hash and state.
 */
export const useMetricsRedirect = (): MetricsRedirect | null => {
  const location = useLocation();

  const pathname = getMetricsRedirectPath(location.pathname);

  if (!pathname) return null;

  return {
    to: { pathname, search: location.search, hash: location.hash },
    state: location.state,
  };
};
